import Field from './Field';

export default class Checkbox extends Field {

    constructor() {
        super();
        this.type = 'Checkbox';
        this.maxSize = [1, 1];
        this.minSize = [1, 1];
    }
    
    create(target, options) {
        let container = document.createElement('div');
        let wrapper = document.createElement('div');
        let input = document.createElement('input');
        let marker = document.createElement('span');

        input.setAttribute('type', 'checkbox');

        if (options.onBlur) {
            input.addEventListener('change', () => {
                options.onBlur();
            });
        }

        input.setAttribute('name',`sheet-${this.name || this.nameId}`);

        if (this.props.auto) {
            input.setAttribute('disabled','disabled');
        }

        container.classList.add('sheet-container');
        input.classList.add('sheet-inputcheckbox');

        this.elements = {container, input};
        this.update(options);

        wrapper.classList.add('sheet-inputcheckbox-wrapper');
        marker.classList.add('sheet-inputcheckbox-marker');

        wrapper.append(input);
        wrapper.append(marker);

        container.append(wrapper);

        target.append(container);
    }

    update(options) {
        this.elements.container.style.fontSize = `${options.unit}px`;
        this.elements.container.style.backgroundColor = options.highlight ? '#444' : 'transparent';
        this.elements.container.style.gridRowStart = 1 + this.y;
        this.elements.container.style.gridColumnStart = 1 + this.x;
        this.elements.container.style.gridRowEnd = (1 + this.y) + (this.height);
        this.elements.container.style.gridColumnEnd = (1 + this.x) + (this.width);

        this.elements.container.classList[options.selectedId === this.id ? 'add' : 'remove']('selected');
        this.elements.input.title = this.props.name || this.props.nameId;
    }

    set(value) {
        this.elements.input.checked = Boolean(value);
    }

    get() {
        return this.elements.input.checked ? 1 : 0;
    }

    clean() {
        this.elements.input.checked = false;
    }

    error() {
        this.elements.input.classList.add('error');
    }

    fix() {
        this.elements.input.classList.remove('error');
    }

}